import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import randomstring from 'uuid/v4';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

class Filter extends React.Component {
    state = {
        local: undefined,
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = (local) => (event) => {
        this.props.onClose(local);
    };

    render() {
        const { local } = this.state;
        const { intl, locals } = this.props;
        const toShow = locals.reduce((arr, l) => {
            if (l.configurado === 3) {
                arr.push(l);
            }
            return arr;
        }, []);
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null, null, null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_18 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'local_table_name' })}
                            </InputLabel>
                            <Select
                                native
                                value={local}
                                onChange={this.handleChange}
                                inputProps={{ name: 'local', id: 'local-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {toShow &&
                                    toShow.length > 0 &&
                                    toShow.map((local) => (
                                        <option key={randomstring()} value={local.id}>
                                            {local.nombre}
                                        </option>
                                    ))}
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null, null, null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button onClick={this.handleClose(local)} color="primary" autoFocus>
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Filter);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/locals/DuplicateMenu.js